import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
  height: auto;
}

.access-page {
  display: flex;
  align-items: center;
  min-height: 100dvh;
  padding: 40px;
  background: var(--ui-canvas);
  color: var(--ui-ink);
  font-family: Pretendard, "Noto Sans KR", sans-serif;
  font-size: 14px;
}

.access-page *, .access-page *::before, .access-page *::after {
  box-sizing: border-box;
}

.access-page ::selection {
  background: var(--ui-selected);
  color: var(--ui-ink);
}

.access-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  width: 100%;
  max-width: 1100px;
  min-height: 680px;
  margin: auto;
  background: var(--ui-paper);
  border: 1px solid var(--ui-line);
  border-radius: 16px;
  box-shadow: none;
  overflow: hidden;
}

.access-panel {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 32px 48px;
  background: var(--ui-paper);
}

.access-header {
  flex: none;
}

.access-wordmark {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  color: var(--ui-ink);
  text-decoration: none;
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.access-symbol {
  display: block;
  flex: none;
  width: 32px;
  height: auto;
}

.access-main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 370px;
  margin: 0 auto;
  padding: 38px 0 12px;
}

.access-form-wrap {
  width: 100%;
  max-width: none;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
  animation: none;
}

.access-form-wrap h1 {
  margin: 0 0 26px;
  color: var(--ui-ink);
  font-size: 30px;
  font-weight: 650;
  letter-spacing: -0.03em;
  line-height: 1.35;
}

.field {
  margin-bottom: 17px;
}

.field label {
  display: block;
  margin: 0 0 8px;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
}

.field:focus-within label {
  color: var(--ui-accent);
}

.field input {
  display: block;
  width: 100%;
  height: 48px;
  padding: 0 14px;
  border: 1px solid var(--ui-control);
  border-radius: 9px;
  background: var(--ui-soft);
  color: var(--ui-ink);
  font: inherit;
  font-size: 16px;
  caret-color: var(--ui-accent);
}

.field input:hover:not(:focus):not(:disabled) {
  border-color: var(--ui-text);
}

.field input:focus {
  outline: 2px solid var(--ui-accent);
  outline-offset: 2px;
  border-color: var(--ui-accent);
  background: var(--ui-paper);
  box-shadow: none;
}

.field input[aria-invalid=true] {
  border-color: var(--ui-danger);
}

.field-hint, .field-error {
  margin: 5px 0 0;
  font-size: 12px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}

.field-hint {
  color: var(--ui-muted);
}

.field-error {
  color: var(--ui-danger);
}

.field input::placeholder {
  color: var(--ui-muted);
  font-size: 14px;
  opacity: 1;
}

.field input:disabled {
  background: var(--ui-soft);
  color: var(--ui-muted);
  cursor: default;
}

.password-field {
  position: relative;
}

.password-field input {
  padding-right: 50px;
}

.password-label-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.password-label-row label {
  margin: 0;
}

.password-label-row a {
  font-size: 12px;
  color: var(--ui-accent);
  text-decoration: none;
  min-height: 28px;
}

.access-links .signup-question {
  width: auto;
  height: auto;
  background: none;
  color: var(--ui-muted);
  font-size: 13px;
}

.access-links a {
  gap: 8px;
}

.password-toggle {
  position: absolute;
  top: 2px;
  right: 2px;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--ui-muted);
  cursor: pointer;
}

.password-toggle:hover:not(:disabled) {
  background: var(--ui-selected);
  color: var(--ui-accent);
}

.password-toggle:disabled {
  opacity: 0.5;
  cursor: default;
}

.submit-button, .success-state .button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 100%;
  min-height: 46px;
  padding: 12px 18px;
  border: 0;
  border-radius: 10px;
  background: var(--ui-accent);
  color: var(--ui-on-accent);
  font-size: 14px;
  font-weight: 650;
  box-shadow: none;
  text-decoration: none;
  cursor: pointer;
}

.submit-button {
  margin-top: 7px;
}

.submit-button:hover:not(:disabled), .success-state .button:hover {
  background: var(--ui-accent-hover);
}

.submit-button:disabled {
  opacity: 0.5;
  cursor: default;
  box-shadow: none;
}

.access-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 14px;
}

.access-links a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
}

.access-links a:last-child {
  color: var(--ui-accent);
  font-weight: 600;
}

.access-links a:hover, .back-link:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
}

.access-page a[aria-disabled=true] {
  opacity: 0.5;
  cursor: default;
}

.access-links > span {
  width: 1px;
  height: 14px;
  background: var(--ui-line);
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin: -10px 0 16px;
  color: var(--ui-muted);
  font-size: 13px;
  text-decoration: none;
}

.form-intro {
  margin: -14px 0 24px;
  color: var(--ui-muted);
  font-size: 14px;
  line-height: 1.75;
  word-break: keep-all;
}

.form-message {
  margin: 14px 0 18px;
  padding: 12px 14px;
  border: 0;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.7;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.form-message.error {
  background: var(--ui-danger-soft);
  color: var(--ui-danger);
}

.form-message.notice {
  background: var(--ui-warning-soft);
  color: var(--ui-warning);
}

.field-note {
  margin: 15px 0 0;
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.75;
}

.success-state h1 {
  margin-bottom: 14px;
  font-size: 26px;
  line-height: 1.45;
}

.success-state p {
  margin: 0 0 20px;
  color: var(--ui-text);
  font-size: 14px;
  line-height: 1.8;
}

.success-state .success-icon {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  margin-bottom: 22px;
  border-radius: 14px;
  background: var(--ui-success-soft);
  color: var(--ui-success);
}

.success-icon svg {
  display: block;
  width: 30px;
  height: 30px;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.access-visual {
  grid-column: 1;
  grid-row: 1;
  position: relative;
  min-width: 0;
  min-height: 480px;
  overflow: hidden;
  isolation: isolate;
  background: var(--ui-navy);
}

.campus-photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 48% center;
}

.access-visual::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(24, 30, 40, 0.76), rgba(24, 30, 40, 0.08) 54%, rgba(24, 30, 40, 0.82));
}

.visual-heading {
  position: absolute;
  top: 40px;
  left: 36px;
  right: 32px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: white;
}

.visual-heading > span:first-child {
  font-size: 38px;
  line-height: 1;
  font-weight: 650;
  letter-spacing: -0.03em;
}

.visual-heading > span:last-child {
  font-size: 14px;
  font-weight: 500;
}

.photo-credit {
  position: absolute;
  bottom: 28px;
  left: 36px;
  right: 36px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 44px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.45);
  color: white;
  font-size: 12px;
  text-decoration: none;
}

.photo-credit:hover {
  color: white;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.photo-credit span:last-child {
  font-size: 20px;
}

.access-page :is(a, button, input, summary):focus-visible {
  outline: 2px solid var(--ui-accent);
  outline-offset: 3px;
}

.photo-credit:focus-visible {
  outline-color: white;
}

.access-page :is(a, button, input, summary) {
  scroll-margin-block: 16px;
}

.reset-next a, .text-action {
  color: var(--ui-accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.reset-next a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
}

.text-action {
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.text-action:disabled {
  opacity: 0.5;
  cursor: default;
}

.success-state .reset-retry {
  margin-top: -8px;
  font-size: 13px;
}

.account-help {
  margin-top: 16px;
  border-top: 1px solid var(--ui-line);
  color: var(--ui-muted);
  font-size: 12px;
  line-height: 1.75;
}

.account-help summary {
  min-height: 44px;
  padding: 12px 0 8px;
  color: var(--ui-text);
  cursor: pointer;
  font-weight: 550;
}

.account-help summary:hover {
  color: var(--ui-accent);
}

.account-help p {
  margin: 4px 0 10px;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

@media (max-width: 1000px) {
  .access-page {
    padding: 24px;
  }
  .access-shell {
    grid-template-columns: minmax(0, 0.85fr) minmax(0, 1fr);
    min-height: 640px;
  }
  .access-panel {
    padding: 24px 32px;
  }
  .visual-heading {
    left: 24px;
  }
  .photo-credit {
    left: 24px;
    right: 24px;
  }
}
@media (max-width: 700px) {
  .access-page {
    display: block;
    padding: 20px 14px;
    background: var(--ui-canvas);
  }
  .access-shell {
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-width: 480px;
    border-radius: 14px;
    overflow: hidden;
  }
  .access-panel {
    flex: none;
    padding: 22px 24px 20px;
  }
  .access-wordmark {
    font-size: 14px;
  }
  .access-main {
    align-items: flex-start;
    justify-content: flex-start;
    padding: 24px 0 12px;
  }
  .access-form-wrap h1 {
    font-size: 26px;
    margin-bottom: 24px;
  }
  .field input {
    height: 48px;
  }
  .password-toggle {
    top: 2px;
    right: 2px;
  }
  .submit-button {
    min-height: 48px;
  }
  .access-visual {
    min-height: 136px;
    height: 136px;
    flex: none;
    margin: 0;
    border-radius: 0;
  }
  .campus-photo {
    object-position: center 55%;
  }
  .visual-heading {
    top: 20px;
    left: 24px;
    gap: 8px;
  }
  .visual-heading > span:first-child {
    font-size: 23px;
  }
  .visual-heading > span:last-child {
    font-size: 12px;
  }
  .photo-credit {
    bottom: 10px;
    left: 24px;
    right: 24px;
    padding-top: 0;
    border-top: 0;
    font-size: 12px;
  }
  .access-links {
    gap: 20px;
  }
}
@media (max-width: 360px) {
  .access-page {
    padding: 12px 10px;
  }
  .access-panel {
    padding: 18px;
  }
  .access-main {
    padding-top: 20px;
  }
  .access-wordmark {
    font-size: 13px;
  }
  .access-shell {
    min-height: 0;
  }
  .photo-credit {
    left: 18px;
    right: 18px;
  }
}
@media (max-height: 700px) and (min-width: 701px) {
  .access-page {
    padding: 20px;
  }
  .access-shell {
    min-height: 570px;
  }
  .access-main {
    align-items: flex-start;
    padding-top: 24px;
  }
  .access-panel {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .field {
    margin-bottom: 15px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .access-page * {
    animation: none;
    transition: none;
  }
}`],
})
export class PageAccessComponent implements OnInit, OnDestroy {
    mode = 'login';
    name = ''; email = ''; password = ''; confirmation = '';
    showPassword = false; busy = false; loading = true;
    entering = false; authenticated = false;
    error = ''; success = ''; csrf = ''; resetToken = '';
    approvalRequired = true; resetAvailable = false;
    subscription: any;
    private modeEpoch = 0;
    private dead = false;
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) {}
    async ngOnInit() {
        await this.service.init();
        if (this.dead) return;
        this.readMode();
        this.subscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) { this.readMode(); this.service.render(); }
        });
        await this.bootstrap();
    }
    readMode() {
        this.modeEpoch++;
        const part = this.router.url.split('?')[0].split('#')[0].split('/')[2] || 'login';
        this.mode = ['login', 'signup', 'forgot', 'reset'].includes(part) ? part : 'login';
        this.error = ''; this.success = ''; this.password = ''; this.confirmation = ''; this.showPassword = false;
        if (this.mode === 'reset') {
            const params = new URLSearchParams(location.hash.slice(1));
            this.resetToken = params.get('token') || this.resetToken;
            if (location.hash) history.replaceState(null, '', location.pathname + location.search);
        }
        document.title = this.title + ' · 한의문헌 저작도구';
    }
    get title() {
        return { login: '로그인', signup: '회원가입', forgot: '비밀번호 찾기', reset: '새 비밀번호' }[this.mode];
    }
    private isCurrent(epoch: number) { return !this.dead && epoch === this.modeEpoch; }
    restartForgot() {
        if (this.mode !== 'forgot' || this.busy || this.loading) return;
        this.success = ''; this.error = '';
        this.service.render();
    }
    async bootstrap() {
        const epoch = this.modeEpoch;
        try {
            const res = await wiz.call('bootstrap');
            if (this.dead) return;
            if (res.code !== 200) throw new Error();
            this.csrf = res.data.csrf;
            this.approvalRequired = res.data.approval_required;
            this.resetAvailable = res.data.reset_available;
            this.authenticated = !!res.data.user;
            if (this.isCurrent(epoch) && this.authenticated && this.mode === 'login') await this.openWorkspace(epoch);
        } catch (e) { if (this.isCurrent(epoch)) this.error = '연결할 수 없습니다. 화면을 새로고침해 주세요.'; }
        if (this.dead) return;
        this.loading = false;
        await this.service.render();
    }
    async openWorkspace(epoch = this.modeEpoch) {
        if (!this.isCurrent(epoch)) return;
        this.entering = true;
        try {
            await this.service.render();
            if (!this.isCurrent(epoch)) return;
            const moved = await this.router.navigateByUrl('/');
            if (!moved && this.isCurrent(epoch)) this.error = '대시보드로 이동하지 못했습니다. 다시 눌러 주세요.';
        } finally {
            if (!this.dead) this.entering = false;
        }
    }
    togglePassword() { this.showPassword = !this.showPassword; this.service.render(); }
    async submit() {
        if (this.dead || this.busy || this.loading || this.success) return;
        const epoch = this.modeEpoch, mode = this.mode;
        this.error = '';
        if (['signup', 'reset'].includes(this.mode) && this.password !== this.confirmation) {
            this.error = '비밀번호가 일치하지 않습니다.'; await this.service.render(); return;
        }
        const action = { login: 'login', signup: 'register', forgot: 'forgot', reset: 'reset' }[mode];
        const values = { name: this.name, email: this.email, password: this.password, token: this.resetToken, csrf: this.csrf };
        this.busy = true;
        try {
            await this.service.render();
            if (!this.isCurrent(epoch)) return;
            if (mode === 'login' && this.authenticated) {
                await this.openWorkspace(epoch);
                return;
            }
            const res = await wiz.call(action, values);
            if (!this.isCurrent(epoch)) return;
            if (res.code !== 200) {
                this.error = res.data?.message || '요청을 처리하지 못했습니다.';
                if (res.code === 403) await this.bootstrap();
            } else if (mode === 'login') {
                this.authenticated = true;
                this.entering = true;
                await this.service.render();
                if (!this.isCurrent(epoch)) return;
                await this.service.auth.init();
                if (!this.isCurrent(epoch)) return;
                await this.openWorkspace(epoch);
                this.password = '';
            } else if (mode === 'signup') {
                this.success = this.approvalRequired ? '가입을 요청했습니다.' : '가입을 완료했습니다.';
            } else {
                this.success = res.data.message;
                if (mode === 'reset') { this.resetToken = ''; await this.bootstrap(); }
            }
        } catch (e) { if (this.isCurrent(epoch)) this.error = '연결이 끊겼습니다. 다시 시도해 주세요.'; }
        finally {
            if (!this.dead) {
                this.busy = false; this.entering = false;
                await this.service.render();
            }
        }
    }
    ngOnDestroy() { this.dead = true; this.modeEpoch++; this.subscription?.unsubscribe(); }
}

export default PageAccessComponent;